import React from 'react';
import classes from './header.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Body, H1 } from '@ui-library/typography';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';

interface IProps {
  icon: IconDefinition;
  header: string;
  description: string;
}

const SetupAccountHeader = ({ icon, header, description }: IProps) => (
  <>
    <FontAwesomeIcon icon={icon} className={classes.icon} />
    <H1 className={classes.header}>{header}</H1>
    <Body secondary className={classes.description}>
      {description}
    </Body>
  </>
);

export default SetupAccountHeader;
